import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'aum-cli-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    registerLocaleData(localeIt);

    this.translate.addLangs(['en', 'it']);
    const currentLang = localStorage.getItem('language')
      ? localStorage.getItem('language')
      : 'en';
    this.translate.setDefaultLang(currentLang);
  }
}
